var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "sortUpIcon",
    d: "M12 12.9394L14.2197 10.7197C14.5126 10.4268 14.9874 10.4268 15.2803 10.7197C15.5732 11.0126 15.5732 11.4875 15.2803 11.7804L11.9571 15.1036C11.5666 15.4941 10.9334 15.4941 10.5429 15.1036L7.21967 11.7804C6.92678 11.4875 6.92678 11.0126 7.21967 10.7197C7.51256 10.4268 7.98744 10.4268 8.28033 10.7197L10.5 12.9394L10.5 1.25C10.5 0.835787 10.8358 0.5 11.25 0.5C11.6642 0.5 12 0.835787 12 1.25V12.9394Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "sortDownIcon",
    d: "M5.5 3.06063L7.71967 5.28029C8.01256 5.57319 8.48744 5.57319 8.78033 5.28029C9.07322 4.9874 9.07322 4.51252 8.78033 4.21963L5.4571 0.896409C5.06658 0.505884 4.43341 0.505887 4.04289 0.89641L0.719669 4.21963C0.426776 4.51253 0.426777 4.9874 0.71967 5.28029C1.01256 5.57319 1.48744 5.57319 1.78033 5.28029L4 3.06062L4 14.75C4 15.1642 4.33579 15.5 4.75 15.5C5.16422 15.5 5.5 15.1642 5.5 14.75V3.06063Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.ce0560bad4f03698b42d3ce959af0cce.svg";
export { ForwardRef as ReactComponent };